import { useSyncExternalStore } from 'react';
import { currentTheme, subscribeTheme, toggleTheme } from '../lib/theme';

// Hook reactivo del tema: mantiene sincronizados el botón del navbar y el
// switch del menú de usuario.
export function useTheme() {
  const theme = useSyncExternalStore(subscribeTheme, currentTheme, () => 'light' as const);
  return { theme, toggle: toggleTheme, isDark: theme === 'dark' };
}
